import React from 'react';
import { StatusInfoErrorWithRequestId } from './StatusInfoErrorWithRequestId';
import { appendModifiers } from '../../../lib/bemUtils/Modifier';
import { StatusInfoPositiveCheck } from './StatusInfoPositiveCheck';
import { StatusInfoModifier } from './partials/StatusInfo';
import { StatusInfoLoading } from './StatusInfoLoading';

type StatusInfoForms = {
  type?: 'success' | 'fail' | 'sending';
  requestId?: string;
  message?: string;
  modifier?: StatusInfoModifier;
};
// for easier testing we provide every status with a data-form-status attribute
export function StatusInfoForms({ type, message, requestId, modifier }: StatusInfoForms) {
  switch (type) {
    case 'success':
      return <StatusInfoPositiveCheck message={message} modifier={modifier} dataFormStatus="success" />;
    case 'sending':
      return <StatusInfoLoading message={message} modifier={modifier} dataFormStatus="sending" />;
    case 'fail':
      return (
        <StatusInfoErrorWithRequestId
          message={message}
          modifier={appendModifiers('red', modifier)}
          requestId={requestId}
          role="alert"
          dataFormStatus="fail"
        />
      );
    default:
      return null;
  }
}
